// RUN BUILD WITH: ng build --configuration=dev

export const environment = {
  production: true,
  url: 'https://www.cms.job.rocks/',
  apiUrl: 'https://www.cms.job.rocks/api',
  ibanApi: "https://services.job.rocks/",
  chatUrl: "http://localhost:3000/",
  chatApiUrl: "http://localhost:3000/api",

  iosAppLink: "https://apps.apple.com/us/app/flexsis/id6751336606",
  androidAppLink: "https://play.google.com/store/apps/details?id=com.sihp.jobrocks.flexsis",

  logoUrl: 'assets/images/Flexsis_logo_RVB_black.png',
  favIconUrl: 'assets/images/Flexsis_logo-icon_RVB_X_black.png',
  agencyName: 'flexsis',

  // monitoring
  sentryDsn: 'https://3af19c63fd69f6191da152fcb513d320@o4511032735039488.ingest.de.sentry.io/4511038077534288',
  sentryEnvironment: 'production',
};